import { render, staticRenderFns } from "./ExamRow.vue?vue&type=template&id=2b45d9c1&scoped=true&"
import script from "./ExamRow.vue?vue&type=script&lang=js&"
export * from "./ExamRow.vue?vue&type=script&lang=js&"
import style0 from "./ExamRow.vue?vue&type=style&index=0&id=2b45d9c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45d9c1",
  null
  
)

export default component.exports